var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 cursor-pointer"},[_c('div',{staticClass:"form-container-input"},[_c('div',{staticClass:"label-icon"},[_c('i',{class:_vm.icon}),_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }